import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../../utils/helper";
import { baseQueryWithAuth } from "../../../BaseQueryWithAuth/baseQueryWithAuth";

export const hydrationfitnessApiService = createApi({
  reducerPath: "hydrationfitnessApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createHydration: builder.mutation({
      query: ({ payload, params }) => {
        const query = queryParams(params);
        return {
          url: `hydrationfitness/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getHydration: builder.query({
      query: (data) => {
        let query = queryParams(data);
        return `hydrationfitness/get${query}`;
      },
      keepUnusedDataFor: 0,
    }),
    updateHydration: builder.mutation({
      query: ({ id, params, ...payload }) => {
        const query = queryParams(params);
        return {
          url: `hydrationfitness/${id}${query}`,
          method: "PUT",
          body: payload,
        };
      },
    }),
  }),
});

export const {
  useCreateHydrationMutation,
  useGetHydrationQuery,
  useUpdateHydrationMutation,
} = hydrationfitnessApiService;
